import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import EastIcon from '@mui/icons-material/East';
import { Box, Drawer, IconButton, Typography, } from "@mui/material";
import { getUsersAllData } from "../../../../actions/usersAllData";
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';




const WishlistDrawer = ({ open, onClose, item }) => {
    // hooks
    const dispatch = useDispatch();

    // Local State
    const [loading, setloading] = useState(true);
    const [Data, setData] = useState([]);

    // Api calls for get Order
    const getData = useCallback(
        async (id, orders) => {
            const res = await dispatch(getUsersAllData(item?._id, "wishlist"));
            setData(res?.data?.data);

            setloading(false);
        },
        [dispatch]
    );

    useEffect(() => {
        getData()
    }, [open, item?._id]);


    return (
        <>
            <Drawer anchor="right"
                open={open}
                onClose={onClose}
                sx={{
                    "& .MuiDrawer-paper": {
                        top: "0px  !important",
                        backgroundColor: "#fafafa",
                        padding: "10px",
                    },
                    "& .css-i9fmh8-MuiBackdrop-root-MuiModal-backdrop": {
                        top: "0px !important"
                    }
                }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Box sx={{ display: "flex", flexDirection: "column", marginTop: 1, p: 1 }}>
                        <Typography
                            className="sofiaRegular"
                            color="#222020"
                            variant="body1"
                            fontWeight="bold"
                            sx={{ fontSize: "16px" }}
                        >
                            Wishlist
                        </Typography>
                        <Typography
                            className="sofiaRegular"
                            variant="body2"
                            sx={{ fontSize: "14px", color: "#1b1919" }}
                        >
                            {Data?.products?.length ?? 0} items
                        </Typography>
                    </Box>
                    <IconButton sx={{ color: 'red', cursor: "pointer", backgroundColor: "transparent", "&:hover": { backgroundColor: "transparent" } }} onClick={onClose}>
                        <CancelRoundedIcon />
                    </IconButton>
                </Box>
                <Box sx={{ mt: 5 }}>
                    {Data?.products?.length > 0 ? (Data?.products?.map((order, index) => (
                        <Box
                            key={index}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                padding: "4px 10px",
                                mb: 1,
                                backgroundColor: "#ffffff",
                                border: "1px solid #ececec",
                                borderRadius: "6px"
                            }}
                        >
                            {/* Image */}
                            <Box
                                component="img"
                                src={order.image}
                                alt={order.title}
                                sx={{
                                    width: 50,
                                    height: 50,
                                    borderRadius: 1,
                                    objectFit: "contain",
                                    border: "1px solid #E0E0E0",
                                }}
                            />
                            {/* Order Details */}
                            <Box sx={{ flex: 1, ml: 1, lineHeight: 0.9 }}>
                                <Typography
                                    className="sofiaRegular"
                                    sx={{ fontWeight: "bold", fontSize: 16, color: "#000" }}>
                                    {order.title}
                                </Typography>
                                <Typography className="sofiaRegular" sx={{ fontSize: 14, color: "#000" }}>
                                    {dayjs(order.createdAt).format("MM/DD/YYYY")} | {dayjs(order.createdAt).format("hh:mm A")}
                                </Typography>
                            </Box>
                            <EastIcon sx={{ fontSize: 16 }} />
                        </Box>
                    ))
                    ) : (
                        <Typography className="sofiaRegular" sx={{ color: "#000", textAlign: "center", mt: 2 }}>
                            No products found.
                        </Typography>
                    )}
                </Box>

            </Drawer>
        </>
    )
}


export default WishlistDrawer